import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getServicedeskPageContextResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import { assetsAnalyticsDataViewDetailsRoute } from '@atlassian/jira-router-routes-assets-routes/src/assetsAnalyticsDataViewDetailsRoute.tsx';
import {
	toPackageName,
	APP_NAMES,
} from '@atlassian/jira-servicedesk-common/src/utils/app-names/index.tsx';
import { assetsAnalyticsDataViewDetailsEntryPoint } from '@atlassian/jira-spa-apps-servicedesk-cmdb-assets-custom-metrics/src/ui/data-view-details/entrypoint.tsx';
import { createChromelessEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { LazyAssetsLayout, AssetsLayout } from '@atlassian/jira-assets-layout/src/ui/async.tsx';
import { getAssetsAppResources } from '@atlassian/jira-router-routes-servicedesk-cmdb-entries/src/common/getCmdbResources.tsx';
import { AssetsPageConfigContainer } from '@atlassian/jira-assets-app-page-config-container/src/ui/async.tsx';
import Spinner from '@atlassian/jira-common-components-spinner/src/view.tsx';

const assetsAnalyticsDataViewDetailsPageEntryPoint = createChromelessEntryPoint({
	main: assetsAnalyticsDataViewDetailsEntryPoint,
});

export const assetsAnalyticsDataViewDetailsRouteEntry = createEntry(
	assetsAnalyticsDataViewDetailsRoute,
	() => ({
		group: 'assets',
		LayoutOverrideComponent: AssetsLayout,
		PageConfigContainerOverride: AssetsPageConfigContainer,
		skeleton: Spinner,
		entryPoint: () => assetsAnalyticsDataViewDetailsPageEntryPoint,
		pageId: () => 'spa-apps/servicedesk/insight/cmdb-assets-analytics-data-view-details-page',
		resources: [...getAssetsAppResources(), ...getServicedeskPageContextResources()],
		forPaint: [LazyAssetsLayout],

		meta: {
			reporting: {
				id: 'insight-assets-analytics-data-view-details',
				packageName: toPackageName(APP_NAMES.ASSETS_APP_ANALYTICS_DATA_VIEW_DETAILS_PAGE),
				teamName: 'ITSM SAGA',
			},
		},

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-assets-entries/src/assetsAnalyticsDataViewDetailsRouteEntry.tsx',
				whichExportToUse: 'assetsAnalyticsDataViewDetailsRouteEntry',
			},

			enabled: true,
		},
	}),
);
